export default __webpack_public_path__ + "static/media/application-form-background-mobile.e9f1812d.png";